"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mxReportFeedback = exports.MixpanelDefaultFeedbackEventName = void 0;

var _fullstory = require("./fullstory");

const MixpanelDefaultFeedbackEventName = 'Feedback';
exports.MixpanelDefaultFeedbackEventName = MixpanelDefaultFeedbackEventName;

const mxReportFeedback = (mx, campaign, question, isSubmitted, isCancelled, response) => {
  if (!mx.mixpanelIntegration) {
    return;
  }

  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const mixpanel = require('mixpanel-browser');

    const mixpanelEvent = {
      'Is Submitted': isSubmitted,
      'Is Cancelled': isCancelled,
      'Feedback Campaign ID': campaign === null || campaign === void 0 ? void 0 : campaign.campaignId,
      'Feedback Campaign Title': campaign === null || campaign === void 0 ? void 0 : campaign.title,
      'Feedback Question ID': question === null || question === void 0 ? void 0 : question.questionId,
      'Feedback Question Title': question === null || question === void 0 ? void 0 : question.title,
      'Feedback Response Value': response === null || response === void 0 ? void 0 : response.value,
      'Feedback Response Text': response === null || response === void 0 ? void 0 : response.text
    };
    const fullStorySessionUrl = (0, _fullstory.getCurrentSessionURL)();

    if (fullStorySessionUrl) {
      mixpanelEvent['FullStory Session URL'] = fullStorySessionUrl;
    }

    mixpanel.track(mx.mixpanelEventNameOverride || MixpanelDefaultFeedbackEventName, mixpanelEvent);
  } catch (_unused) {
    /* do nothing */
  }
};

exports.mxReportFeedback = mxReportFeedback;